<script setup lang="ts">
import { router } from "@inertiajs/vue3"
import { computed, ref } from "vue"

import { dueLabel, timeAgo } from "@/lib/format"
import { ICON } from "@/lib/icons"
import { itemLoanPath } from "@/routes"

const props = defineProps<{
  loanId: string
  itemId: string
  direction: "lent" | "borrowed"
  personName: string
  loanedOn: string
  expectedReturnOn: string | null
  overdue: boolean
}>()

const title = computed(() =>
  props.direction === "lent" ? `Lent to ${props.personName}` : `Borrowed from ${props.personName}`,
)

const description = computed(() => {
  let text = timeAgo(props.loanedOn)
  if (props.expectedReturnOn) {
    text += ` · ${dueLabel(props.expectedReturnOn)}`
  }
  return text
})

const returning = ref(false)

function markReturned() {
  returning.value = true
  router.patch(
    itemLoanPath(props.itemId, props.loanId),
    { return: "1" },
    {
      preserveScroll: true,
      onFinish: () => (returning.value = false),
    },
  )
}
</script>

<template>
  <UAlert
    :title="title"
    :description="description"
    :icon="ICON.loan"
    :color="overdue ? 'error' : 'warning'"
    variant="subtle"
  >
    <template #actions>
      <UButton
        label="Mark Returned"
        :icon="ICON.loanReturn"
        size="xs"
        :color="overdue ? 'error' : 'warning'"
        variant="subtle"
        :loading="returning"
        @click="markReturned"
      />
    </template>
  </UAlert>
</template>
